// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","105":"3f377bbf5c08c288acf0","108":"f03079819f8757c97349","243":"307c1cf31df043fbcfea","682":"010d3484390bfdcb1778","688":"4ae0452d68744a66654f","852":"b663edd957f49e4c36a0"}[chunkId] + ".bundle.js";
};